module.exports = __webpack_public_path__ + "static/img/02.46099e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/02.jpg
// module id = SSFU
// module chunks = 6